/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  content: Yup.string().required('Content is required')
});

const EditEmployeeDetailModal = ({ show, handleClose, data }) => {
  if (!data) return null;

  return (
    <Modal show={show} onHide={handleClose}>
      <Formik
        initialValues={{ title: data.title, content: data.content }}
        validationSchema={validationSchema}
        onSubmit={values => {
          handleClose();
        }}
      >
        {({ handleSubmit, errors, touched }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Edit {data.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="formTitle">
                <Form.Label>Title</Form.Label>
                <Field
                  name="title"
                  as={Form.Control}
                  isInvalid={touched.title && !!errors.title}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.title}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formContent">
                <Form.Label>Content</Form.Label>
                <Field
                  name="content"
                  as="textarea"
                  rows={3}
                  className="form-control"
                  isInvalid={touched.content && !!errors.content}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.content}
                </Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditEmployeeDetailModal;
